import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import {
  setGlobalTaskNotificationCount,
  setTaskNotificationCount,
} from '../../../../redux/slices/task-notification.slice';
import { getTaskNotification } from '../service';
import { clientDetails } from '../../../../constants';
export interface TastNotificationInterface {
  taskNotification: {
    taskNotificationCount: number;
  };
}
export interface TaskNotificationProps {
  projectId?: number;
}

const TaskNotification = (projectId: { projectId?: number }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const response = async () => {
      try {
        if (!clientDetails?.client_id) return;
        const response = await getTaskNotification(
          clientDetails?.client_id,
          projectId?.projectId
        );
        if (response?.data?.status)
          if (projectId?.projectId) {
            dispatch(
              setGlobalTaskNotificationCount(response?.data?.data?.count)
            );
          } else {
            dispatch(setTaskNotificationCount(response?.data?.data?.count));
          }
      } catch (error) {
        console.error('Failed to fetch task notification:', error);
      }
    };
    response();
  }, [clientDetails?.client_id]);

  return null;
};
export default TaskNotification;
